import ListAltIcon from '@material-ui/icons/ListAlt';
import TicketList from './TicketList';
// import TicketCreate from './TicketCreate';

export default {
    list: TicketList,
    // create: TicketCreate,
    icon: ListAltIcon,
};
